import { chartStyles } from '../common/common-chart-utils/common-chart-styles';

type ChartStylesOptions = {
  benchmarkSeriesDetails?: {
    id: string;
    benchmarkColor: string;
  }[];
};

export const lineChartStyles = (options?: ChartStylesOptions) => {
  const { benchmarkSeriesDetails = [] } = options ?? {};
  const benchmarkStyling = Object.fromEntries(
    benchmarkSeriesDetails.map(({ id, benchmarkColor }) => {
      return [
        `.MuiLineElement-series-${id}`,
        {
          stroke: benchmarkColor,
          strokeDasharray: '4',
        },
      ];
    })
  );
  return {
    ...chartStyles(),
    ...benchmarkStyling,
  };
};
